import { useState, useEffect, useContext } from "react";
import placeholder from "../inc/placeholder.jpg";
import { SiteContext } from "../contexts/SiteContext";
import { ViewContext } from "../contexts/ViewContext";
import { Link } from "react-router-dom";
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  makeStyles,
  Fade,
  Tooltip,
  Hidden,
  IconButton,
} from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewGridIcon from "@material-ui/icons/ViewModule";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1rem",
    marginBottom: "1rem",
    marginTop: "1rem",
    position: "relative",
  },
  media: { paddingBottom: "100%" },
  horizCard: {
    marginBottom: "1rem",
  },
  link: {
    color: "black",
    textDecoration: "none",
  },
  horizCardActionArea: {
    display: "flex",
    justifyContent: "start",
  },
  horizMedia: {
    paddingBottom: "12%",
    paddingRight: "12%",
  },
  horizCardContent: {},
}));

//---------------
// MAIN COMPONENT
//---------------

function Regions() {
  const classes = useStyles();
  const [regions, setRegions] = useState();
  const [loading, setLoading] = useState(true);
  const { selectedSite } = useContext(SiteContext);
  const { regionsView, setRegionsView } = useContext(ViewContext);

  useEffect(() => {
    const fetchData = async () => {
      let url = `${process.env.REACT_APP_API_URL}/regions?sort=name`;
      const res = await fetch(url, { credentials: "include" });
      let allRegions = await res.json();
      if (allRegions.success) {
        setRegions(
          allRegions.data.filter((region) => {
            //Log the region.site._id and selectedSite._id if they don't match
            if (region.site._id !== selectedSite._id) console.log(region.site._id, selectedSite._id);
            return (region.site._id == selectedSite._id)
          })
        );
      } else {
        console.log(allRegions.error);
      }
    };
    fetchData();
    setLoading(false);
  }, []);

  if (loading || !regionsView) {
    return "Loading...";
  }

  return (
    <>
      {regions && regions.length > 0 && (
        <Fade in={!loading}>
          <Paper className={classes.paper}>
            <Typography
              style={{ marginBottom: "1rem" }}
              component="h3"
              variant="h6"
              align="center"
            >
              Regions
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "absolute",
                right: ".5rem",
                top: ".5rem",
              }}
            >
              <Hidden smDown>
                {regionsView === "grid" ? (
                  <Tooltip
                    title="View regions as a list"
                    aria-label="View regions as a list"
                    placement="top"
                  >
                    <IconButton
                      aria-label="View the regions in a list format"
                      onClick={() => setRegionsView("list")}
                      variant="contained"
                    >
                      <ViewListIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title="View regions as a grid"
                    aria-label="View regions as a grid"
                    placement="top"
                  >
                    <IconButton
                      aria-label="View the regions in a grid format"
                      onClick={() => setRegionsView("grid")}
                      variant="contained"
                    >
                      <ViewGridIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Hidden>
            </div>

            {selectedSite && selectedSite.regionsImage &&
              <Typography
                style={{ marginBottom: "1rem" }}
                component="h4"
                variant="p"
                align="center"
              >
                <a href={`${process.env.REACT_APP_FILE_URL}/${selectedSite.regionsImage.fileName}`}>View Regions Map</a>
              </Typography>
            }


            <Hidden smDown>
              {regionsView === "list" ? (
                <RegionsList regions={regions} />
              ) : (
                <RegionsGrid regions={regions} />
              )}
            </Hidden>

            {/*On mobile devices, only allow displaying the RegionsGrid*/}
            <Hidden mdUp>
              <RegionsGrid regions={regions} />
            </Hidden>
          </Paper>
        </Fade>
      )}
    </>
  );
}

//----------
// GRID VIEW
//----------

function RegionsGrid({ regions }) {
  const classes = useStyles();
  const { selectedSite } = useContext(SiteContext);

  if (!regions) {
    return "Please pass regions to the RegionsGrid component...";
  }

  return (
    <Grid container spacing={3}>
      {regions.map((region, index) => {
        return (
          <Grid item key={index} xs={6} sm={4} md={3} lg={3}>
            <Card elevation={0} className={classes.card} aria-label>
              <Link
                className={classes.link}
                to={`/${selectedSite.slug}/regions/${region.slug}`}
              >
                <CardActionArea>
                  <CardMedia
                    className={classes.media}
                    image={
                      region.featuredImage
                        ? `${process.env.REACT_APP_FILE_URL}/${region.featuredImage.thumbnailName}`
                        : placeholder
                    }
                    title={region.name}
                  />
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}

//----------
// LIST VIEW
//----------
//
function RegionsList({ regions }) {
  const classes = useStyles();
  const { selectedSite } = useContext(SiteContext);

  if (!regions) {
    return "Please pass regions to the RegionsList component...";
  }

  return (
    <>
      {regions.map((region, index) => {
        return (
          <Card key={index} className={classes.horizCard}>
            <Link
              className={classes.link}
              to={`/${selectedSite.slug}/regions/${region.slug}`}
            >
              <CardActionArea className={classes.horizCardActionArea}>
                <CardMedia
                  className={classes.horizMedia}
                  image={
                    region.featuredImage
                      ? `${process.env.REACT_APP_FILE_URL}/${region.featuredImage.thumbnailName}`
                      : placeholder
                  }
                  title={region.name}
                />
                <CardContent className={classes.horizCardContent}>
                  <Typography variant="h6" component="h4">
                    {region.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Link>
          </Card>
        );
      })}
    </>
  );
}

export default Regions;
